/* VYPER Wishlist — localStorage-basiert, kein 3rd-party.
 * API: window.VYPER.wishlist.{add,remove,toggle,has,all,count,clear}
 * Custom Event: 'vyper:wishlist:change' (detail: { handles, count })
 */
(function () {
  'use strict';
  var KEY = 'vyper_wishlist';
  var EVENT = 'vyper:wishlist:change';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {}
    var ev = new CustomEvent(EVENT, { detail: { handles: handles.slice(), count: handles.length } });
    window.dispatchEvent(ev);
  }

  var API = {
    all: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: function (handle) {
      if (!handle) return false;
      var arr = read();
      if (arr.indexOf(handle) !== -1) return false;
      arr.push(handle);
      write(arr);
      return true;
    },
    remove: function (handle) {
      var arr = read();
      var i = arr.indexOf(handle);
      if (i === -1) return false;
      arr.splice(i, 1);
      write(arr);
      return true;
    },
    toggle: function (handle) {
      return API.has(handle) ? (API.remove(handle), false) : (API.add(handle), true);
    },
    clear: function () { write([]); }
  };

  window.VYPER = window.VYPER || {};
  window.VYPER.wishlist = API;

  // ── DOM sync: Header-Badge + PDP-Buttons ─────────────────────────────
  function updateHeaderBadge() {
    var count = API.count();
    document.querySelectorAll('[data-vyper-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      // Always show the badge (including "0") so the white background circle
      // never appears empty in the header.
      el.removeAttribute('hidden');
    });
    document.querySelectorAll('[data-vyper-wishlist-link]').forEach(function (link) {
      link.classList.toggle('has-items', count > 0);
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-vyper-wishlist-btn]').forEach(function (btn) {
      var handle = btn.getAttribute('data-vyper-wishlist-btn');
      var active = API.has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('[data-vyper-wishlist-label]');
      if (label) label.textContent = active ? 'Auf der Wunschliste' : 'Auf die Wunschliste';
    });
  }

  function bindButtons() {
    document.querySelectorAll('[data-vyper-wishlist-btn]:not([data-vyper-wishlist-bound])').forEach(function (btn) {
      btn.setAttribute('data-vyper-wishlist-bound', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var handle = btn.getAttribute('data-vyper-wishlist-btn');
        if (!handle) return;
        API.toggle(handle);
      });
    });
  }

  function init() {
    updateHeaderBadge();
    updateButtons();
    bindButtons();
  }

  window.addEventListener(EVENT, function () { updateHeaderBadge(); updateButtons(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // KEINE MutationObserver — verursachte infinite-loop weil unsere updateButtons()
  // selbst attribute setzt (classList, aria-pressed) was die Observer wieder triggert.
  // Re-bind für dynamisch eingefügten Content via manueller window.VYPER.wishlist.rescan().
  window.VYPER.wishlist.rescan = function () { bindButtons(); updateButtons(); updateHeaderBadge(); };

  // ── Wishlist-Page-Renderer: fetched live product data ────────────────
  // Auto-runs if container #vyper-wishlist-page is present
  function renderWishlistPage() {
    var container = document.getElementById('vyper-wishlist-page');
    if (!container) return;
    var handles = API.all();
    if (handles.length === 0) {
      container.innerHTML = '<div class="vyper-wishlist-page__empty"><p>Deine Wunschliste ist noch leer.</p><a href="/collections/all" class="vyper-wishlist-page__cta">Produkte entdecken</a></div>';
      return;
    }
    container.innerHTML = '<div class="vyper-wishlist-page__loading">Lade Wunschliste …</div>';
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) {
        return r.ok ? r.json() : null;
      }).catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(function (p) { return p; });
      if (valid.length === 0) {
        container.innerHTML = '<div class="vyper-wishlist-page__empty"><p>Deine Wunschliste ist leer oder die Produkte sind nicht mehr verfügbar.</p></div>';
        return;
      }
      var html = '<div class="vyper-wishlist-page__grid">';
      valid.forEach(function (p) {
        var price = (p.price / 100).toFixed(2);
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        html += '<div class="vyper-wishlist-item" data-handle="' + p.handle + '">' +
          '<a href="/products/' + p.handle + '" class="vyper-wishlist-item__img-link">' +
            (img ? '<img class="vyper-wishlist-item__img" src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="vyper-wishlist-item__body">' +
            '<a href="/products/' + p.handle + '" class="vyper-wishlist-item__name">' + p.title + '</a>' +
            '<div class="vyper-wishlist-item__price">CHF ' + price + '</div>' +
            '<div class="vyper-wishlist-item__actions">' +
              '<form action="/cart/add" method="post" enctype="multipart/form-data">' +
                '<input type="hidden" name="id" value="' + (p.variants && p.variants[0] && p.variants[0].id) + '">' +
                '<button type="submit" class="vyper-wishlist-item__atc">+ In den Warenkorb</button>' +
              '</form>' +
              '<button type="button" class="vyper-wishlist-item__remove" data-vyper-wishlist-btn="' + p.handle + '" aria-label="Aus Wunschliste entfernen">✕</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      html += '</div>';
      container.innerHTML = html;
      bindButtons();
    });
  }

  window.addEventListener(EVENT, function () {
    if (document.getElementById('vyper-wishlist-page')) renderWishlistPage();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderWishlistPage);
  } else {
    renderWishlistPage();
  }
})();
